import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  IsAllowed,
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { OrgUnit } from 'cb-model';

export const OrgUnitSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(OrgUnit);
  const gCacheQueryItem = useCacheQuery(OrgUnit, queryOptions);

  return (
    <>
      <PageTitle verb="Search" entity={OrgUnit} subtitle="Manage your organisation hierarchy" />
      <Section>
        <IsAllowed entity={OrgUnit} action="create">
          <Link to="/admin/org-unit/create">
            <Button size="sm" variant="primary">
              Create a new Org Unit
            </Button>
          </Link>
          <div className="mb20px" />
        </IsAllowed>
        <PaginatorAndListSettings
          entity={OrgUnit}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
